import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const HomeIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g fill={color}>
          <path
            d="M22.75 20.122v-7.2l-3.606-3.606c-1.188-1.188-1.782-1.782-2.467-2.005a3 3 0 0 0-1.854 0c-.685.223-1.28.817-2.467 2.005L8.75 12.922v7.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.31c.642.328 1.482.328 3.162.328h4.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162Z"
            fillRule="nonzero"
            opacity=".12"
          />
          <path d="M15.364 7.561a1.25 1.25 0 0 1 .81.014c.092.036.213.108.405.272l.087.075c.21.187.462.439.816.793l3.332 3.331c.544.544.726.733.854.943.124.201.215.42.27.65.057.239.062.501.062 1.27v5.213c0 .852 0 1.446-.038 1.909-.038.454-.107.715-.207.912-.216.423-.56.768-.984.983-.197.101-.458.17-.912.207-.462.038-1.057.039-1.909.039h-4.4c-.852 0-1.447-.001-1.91-.039-.453-.037-.714-.106-.911-.207a2.25 2.25 0 0 1-.984-.983c-.1-.197-.17-.458-.207-.912-.037-.463-.038-1.057-.038-1.91V14.91c0-.77.005-1.032.062-1.271.055-.23.146-.449.27-.65.127-.209.308-.397.847-.936l.007-.007 3.332-3.331.074-.075a15.49 15.49 0 0 1 .869-.827c.195-.161.312-.222.403-.252Zm-5.913 3.6L5.22 15.39a.75.75 0 1 0 1.06 1.06L8 14.733v5.422c0 .813 0 1.468.043 2 .045.546.14 1.026.366 1.47a3.75 3.75 0 0 0 1.639 1.639c.444.226.924.32 1.47.365.531.044 1.187.044 2 .044h4.464c.813 0 1.469 0 2-.044.546-.044 1.026-.139 1.47-.365a3.75 3.75 0 0 0 1.64-1.639c.226-.444.32-.924.365-1.47.043-.532.043-1.187.043-2v-5.422l1.72 1.72a.75.75 0 1 0 1.06-1.06l-4.232-4.233-.113-.113-.06-.06-3.332-3.332-.022-.021a17.792 17.792 0 0 0-.971-.93c-.29-.247-.59-.451-.95-.568a2.752 2.752 0 0 0-1.7 0c-.36.117-.66.321-.95.568-.279.237-.594.552-.972.93l-.021.021-3.331 3.331-.06.06-.115.115Z" />
        </g>
      </g>
    </svg>
  );
};
